// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"0a83a274","416":"004d354f"}[chunkId] + ".chunk.css";
};